import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { getAxios } from "src/helpers/index";
import moment from "moment";
import axios from "axios";
import _ from "lodash";
import { AppConfigs } from "src/settings";

//Get all notification data for dashboard
export const getAllNofificationForDashboard = createAsyncThunk("dashboard/getAllNofificationForDashboard", async (model, thunkAPi) => {
    try {
        let res = await getAxios().get(`ActivityLog?currentPage=1&pageSize=10000`);
        let newData = {
            ...res.data,
            result: _.map(res.data?.result || [], (d) => JSON.parse(d))
        }
        return newData;
    } catch (error) {
        return thunkAPi.rejectWithValue(error);
    }
});

export const setSelectedDepotDropdownValueForDashboard = createAction(
    'dashboard/setSelectedDepotDropdownValueForDashboard',
    (model) => {
        return { payload: model }
    }
)

export const isDropdownOpenFlag = createAction(
    'dashboard/isDropdownOpenFlag',
    (model) => {
        return { payload: model }
    }
)

export const setSelectedProjectManagerDashboardDropdownValues = createAction(
    "dashboard/setSelectedProjectManagerDashboardDropdownValues",
    (model) => {
      return { payload: model };
    }
  );

export const commonFileUpload = createAsyncThunk(
    "commonFile",
    async (model, thunkApi) => {
        try {
            let userDetails = JSON.parse(localStorage.getItem("userDetails"));
            let res = await axios.post(`${AppConfigs.apiBaseUrl}common/file/upload`, model, {
                headers: {
                    'Authorization': `Bearer ${userDetails?.token}`,
                    'Content-Type': 'multipart/form-data'
                }
            })
            return res?.data || [];
        } catch (error) {
            thunkApi.rejectWithValue("error");
        }
    }
);
